export default {
    CLIENT_ID: `${process.env.VUE_APP_CLIENT_ID}`,
    CLIENT_SECRET: `${process.env.VUE_APP_CLIENT_SECRET}`,
    imagesURL: `${process.env.VUE_APP_DOMAIN_URL}`,

    domainURL: `${process.env.VUE_APP_DOMAIN_URL}/`,
    resetPasswordURL: `${process.env.VUE_APP_DOMAIN_URL}`,

    // /* sandbox */ CHECKOUT_PUBLIC_API_KEY: 'pk_sbox_jwvr24ls3dgmosm5hf2kwgd6qam',
    /* production */ CHECKOUT_PUBLIC_API_KEY: 'pk_diflje6hb4a3y6mfdcxtsxmumqy',
    recaptchaKey : `${process.env.VUE_APP_RECAPTCHA_KEY}`,
    imagePath : `${process.env.VUE_APP_IMAGE_PATH}`,
    setCookie:(cname,cvalue,exdays)=>{
      const d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      let expires = "expires=" + ((cvalue)?d.toUTCString():new Date());
      document.cookie = cname + "=" + encodeURIComponent(cvalue) + ";" + expires + ";path=/";
    },
    getCookie:(cname)=>{
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },
    delete_cookie:(name) => {
      document.cookie = name +'=; path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },
    brokerFAQ : {
        'What is CopyTrading?' : "CopyTrading allows you to copy positions from top Leaders in real time. Just choose the Leader you wish to Copy and you're good to go!",
        'How do I create a Demo account?' : `A Demo is already created automatically for you upon signup, just go to Leaders page, choose a leader and start CopyTrading!`,
        'Does ZuluTrade support multiple Investor accounts?' : 'You can open as many Real Investor accounts as you please, there is no limitation. On the next step, you will be able to either create a new broker account or link your existing account.'
    },
    connectBrokerFAQ : {
        'My Broker is not on the list, what do I do?' : "If your Broker is not on the list do not worry! Just link your broker account as 'Other Broker'. Your Platform credentials will be required (please note, these are NOT the broker portal credentials, but the ones needed for the trading platform. If any IP or Server is requested and you don't know it, just ask your broker.",
        "'I'm a Broker, how do I get added to this list?'" : `Just reach out to partnerships@zulutrade.com and we'll take care of it`,
    },
    becomeALeaderFAQ : {
        "What is a Strategy Title and Description?" : `The Strategy title is how other users will see your strategy in the Leaders section. For Strategy Description, please provide a comprehensive explanation of your Trading Strategy (500-2000 characters). These are both very important to attract Copiers.`,
        'Can I become a Leader with a Demo account?' : "Demo broker accounts are not able to become Leaders in ZuluTrade. You can create a Live broker for free, just add a new Trading account and choose 'Create a broker account'. If you were registered with a 'Demo Trader' account in the past, we will maintain your account. ",
    },
    cretioCountryJson: {
        'AE': '104592',
        'AR': '104593',
        'AT': '104594',
        'AU': '103297',
        'BR': '104595',
        'CA': '104596',
        'CH': '104597',
        'CZ': '104598',
        'DE': '103300',
        'ES': '103296',
        'GR': '103294',
        'ID': '104599',
        'IT': '103060',
        'MY': '104600',
        'NL': '103308',
        'PH': '104601',
        'PL': '103295',
        'QA': '104602',
        'SA': '104603',
        'SG': '104604',
        'TH': '104605',
        'ZA': '104606'
    },
    jurisdiction_tax_residence_list : {
		1: 'Country does not issue TIN.',
		2 : 'Unable to obtain TIN',
		3: 'No TIN is required'
	},
    bussinessActivity: { '01': 'accountancy', '02': 'admin_secretarial', '03': 'adult_industry', '04': 'agriculture', '05': 'art', '06': 'art_antique_dealers', '07': 'bank_note_traders', '08': 'betting', '09': 'catering_hospitality', '10': 'creative_media', '11': 'currency_exchange_money_transfer', '12': 'dealers_high_value_metals', '13': 'education', '14': 'emergency_services', '15': 'engineering', '16': 'finance', '17': 'gambling_related', '18': 'government', '19': 'healthcare', '20': 'hr', '21': 'it', '22': 'journalism_communication', '23': 'legal', '24': 'leisure_enternainment_tourism', '25': 'logistics_transportation', '26': 'manufacturing', '27': 'marketing', '28': 'military', '29': 'pharmaceuticals', '30': 'property_constructions_trades', '31': 'retail_wholesale', '32': 'sales', '33': 'social_care_services', '34': 'telecommunications', '35': 'unregulated_charities', '36': 'weapon_manufacturing' },
}
